import leads from './leads'
import rewards from './rewards'
import dashboard from './dashboard'
import leaderboard from './leaderboard'
import program from './program'

export default {
  homeMenu: {
    name: '我的推荐',
    desc: '进行推荐，检查推荐进度，赚取和兑换奖励',
    noReferralPremiumDesc: '进行推荐'
  },
  rewards,
  leads,
  dashboard,
  leaderboard,
  program
}
